/* Mobile add-to-cart: stay anchored to the viewport, not an animated product column.
   Use the existing Shopify product form so variant, quantity, cart drawer and errors stay in sync. */
(() => {
  const stickySelector = '[data-mimu-mobile-sticky-atc]';

  function initializeSticky(root) {
    if (!root || root.dataset.mimuStickyInitialized === 'true') return;

    const formId = root.dataset.productFormId;
    const form = formId ? document.getElementById(formId) : null;
    const mainButton = form ? form.querySelector('button[type="submit"][name="add"]') : null;
    const stickyButton = root.querySelector('[data-mimu-sticky-button]');
    if (!form || !mainButton || !stickyButton) {
      root.hidden = true;
      return;
    }

    root.dataset.mimuStickyInitialized = 'true';

    // A transformed/animated product-info wrapper becomes a containing block
    // for position:fixed, making the bar float over the product copy on iOS.
    document.body.appendChild(root);
    root.hidden = false;

    const initialLabel = stickyButton.textContent.trim() || 'Add to cart';
    const priceLabel = root.querySelector('[data-mimu-sticky-price]');
    const sectionId = root.dataset.sectionId;
    const livePrice = sectionId ? document.getElementById('price-' + sectionId) : null;
    let queued = false;
    let currentVisible = false;

    function getLivePrice() {
      if (!livePrice || !priceLabel) return;
      const onSale = livePrice.querySelector('.price--on-sale');
      const sale = livePrice.querySelector('.price__sale .price-item--sale');
      const regular = livePrice.querySelector('.price__regular .price-item--regular');
      const amount = ((onSale && sale) ? sale : regular || sale)?.textContent.trim();
      if (amount) priceLabel.textContent = amount;
    }

    function update() {
      if (!root.isConnected || !mainButton.isConnected) {
        document.body.classList.remove('mimu-sticky-atc-visible');
        return;
      }

      const soldOut = mainButton.disabled || Boolean(form.querySelector('input[name="id"]:disabled'));
      const adding = mainButton.getAttribute('aria-disabled') === 'true' || mainButton.classList.contains('loading');
      const isMobile = window.matchMedia('(max-width: 749px)').matches;

      // Don't show before shoppers have even reached the first purchase button.
      const mainButtonIsAboveScreen = mainButton.getBoundingClientRect().bottom < 0;
      const cartOpen = Boolean(document.querySelector('cart-drawer.active, cart-notification.active'));
      const show = isMobile && mainButtonIsAboveScreen && !cartOpen;

      stickyButton.disabled = soldOut || adding;
      stickyButton.textContent = soldOut ? 'Unavailable' : adding ? 'Adding…' : initialLabel;

      if (currentVisible !== show) {
        currentVisible = show;
        root.classList.toggle('is-visible', show);
        root.setAttribute('aria-hidden', String(!show));
        root.toggleAttribute('inert', !show);
        document.body.classList.toggle('mimu-sticky-atc-visible', show);
      }
      getLivePrice();
    }

    function scheduleUpdate() {
      if (queued) return;
      queued = true;
      window.requestAnimationFrame(() => {
        queued = false;
        update();
      });
    }

    stickyButton.addEventListener('click', () => {
      if (mainButton.disabled || mainButton.getAttribute('aria-disabled') === 'true' || !form.isConnected) return;
      // Native form submission enters Dawn's existing AJAX cart flow,
      // preserving selected variant, quantity, callbacks and cart feedback.
      if (typeof form.requestSubmit === 'function') form.requestSubmit(mainButton);
      else mainButton.click();
      scheduleUpdate();
    });

    const availabilityObserver = new MutationObserver(scheduleUpdate);
    availabilityObserver.observe(mainButton, {
      attributes: true,
      attributeFilter: ['disabled', 'aria-disabled', 'class'],
      childList: true,
      subtree: true
    });

    if (livePrice) {
      const priceObserver = new MutationObserver(scheduleUpdate);
      priceObserver.observe(livePrice, { childList: true, subtree: true });
    }

    window.addEventListener('scroll', scheduleUpdate, { passive: true });
    window.addEventListener('resize', scheduleUpdate, { passive: true });
    document.addEventListener('variant:change', scheduleUpdate);

    document.addEventListener('shopify:section:unload', (event) => {
      if (event.detail?.sectionId === sectionId) {
        document.body.classList.remove('mimu-sticky-atc-visible');
        root.remove();
      }
    });

    update();
  }

  function initializeAll() {
    document.querySelectorAll(stickySelector).forEach(initializeSticky);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeAll, { once: true });
  } else {
    initializeAll();
  }
  document.addEventListener('shopify:section:load', initializeAll);
})();
